type TokenGetter = () => Promise<string>;

let getter: TokenGetter | null = null;

/** Registers the access-token getter used to authorize API requests. */
export const setAccessTokenGetter = (fn: TokenGetter | null) => {
  getter = fn;
};

// Returns null (rather than throwing) when a token can't be acquired — e.g. the
// merchant API audience isn't configured in dev — so requests still go out and
// the backend's dev path handles them; in stage/prod a tokenless request 401s.
export const getAccessToken = async () => {
  if (!getter) return null;
  try {
    return await getter();
  } catch {
    return null;
  }
};
